export default {
  strings: {
    pluginNameGooglePhotosPicker: 'Google Photos'
  }
};